export default __webpack_public_path__ + "static/media/030_corner1.460cc954.mp4";